// extracted by mini-css-extract-plugin
export default {"container":"timer_container__EEPMP","blinkSeparator":"timer_blinkSeparator__2V0cd","separator":"timer_separator__3rzdb","blink":"timer_blink__3Y0s2"};